/**
 * HI engine — size memory across colour swatches.
 *
 * Each colourway is a separate product, so a swatch tap is a full page load
 * that starts on the first size again. This carries the size the shopper chose
 * to the next colour via ?size= on the swatch link, and pre-selects it on
 * arrival when that size is in stock there.
 *
 * color-swatches.js already contains this carry-over, but its picker lookup
 * compares the whole legend text to 'Size' and the size-quiz button sits inside
 * that legend, so it never matches. It is left untouched: this file only adds.
 *
 * Runs for every shopper. No sizes are stored: no localStorage, no cookies.
 */
(function () {
  'use strict';

  var SWATCH = '.color-swatches__swatch';

  try {
    var params = new URLSearchParams(window.location.search);
    // Only carry a size the shopper actually chose (or brought from the
    // previous colour) — not the first size the page happens to start on.
    var knownSize = null;

    function isSizeInput(el) {
      return !!(el && el.type === 'radio' && /^Size/.test(el.name || '') && el.closest('variant-selects'));
    }

    // Looked up fresh each time: a variant change re-renders the picker.
    function findSizeFieldset() {
      var fieldsets = document.querySelectorAll('variant-selects fieldset');
      var i;
      for (i = 0; i < fieldsets.length; i++) {
        if (isSizeInput(fieldsets[i].querySelector('input[type="radio"]'))) return fieldsets[i];
      }
      // Fallback: the legend's own first text node (the quiz button inside the
      // legend is why a whole-text comparison fails).
      for (i = 0; i < fieldsets.length; i++) {
        var legend = fieldsets[i].querySelector('legend');
        var first = legend && legend.firstChild;
        if (first && first.nodeType === 3 && first.nodeValue.trim() === 'Size') return fieldsets[i];
      }
      return null;
    }

    function withSize(href, size) {
      var url = new URL(href, window.location.href);
      url.searchParams.set('size', size);
      return url.toString();
    }

    function rewriteSwatchLinks() {
      if (!knownSize) return;
      var swatches = document.querySelectorAll(SWATCH);
      for (var i = 0; i < swatches.length; i++) {
        if (swatches[i].href) swatches[i].href = withSize(swatches[i].href, knownSize);
      }
    }

    function preselectFromUrl() {
      var size = params.get('size');
      var fieldset = size && findSizeFieldset();
      if (!fieldset) return;
      var inputs = fieldset.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (input.value !== size) continue;
        // Sold out or missing in this colour: leave the page as it is today.
        if (input.disabled || input.classList.contains('disabled')) return;
        knownSize = size;
        if (!input.checked) {
          input.checked = true;
          // Same event a real pick fires, so the theme updates the variant,
          // price, address and Add to cart exactly as it normally does.
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    }

    function init() {
      preselectFromUrl();
      rewriteSwatchLinks();

      // Delegated on document so it survives the picker being re-rendered.
      document.addEventListener('change', function (e) {
        try {
          if (!isSizeInput(e.target) || !e.target.checked) return;
          knownSize = e.target.value;
          rewriteSwatchLinks(); // long-press / open-in-new-tab carry the size too
        } catch (err) { /* keep today's behaviour */ }
      });

      // Capture phase so the link is updated before navigation. No
      // preventDefault: the theme's own click handler (which saves the scroll
      // position) still runs.
      document.addEventListener('click', function (e) {
        try {
          var swatch = e.target && e.target.closest && e.target.closest(SWATCH);
          if (swatch && knownSize && swatch.href) swatch.href = withSize(swatch.href, knownSize);
        } catch (err) { /* keep today's behaviour */ }
      }, true);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        try { init(); } catch (e) { /* keep today's behaviour */ }
      });
    } else {
      init();
    }
  } catch (e) { /* any error leaves today's behaviour */ }
})();
